import script from "./Availability.vue?vue&type=script&setup=true&lang=js"
export * from "./Availability.vue?vue&type=script&setup=true&lang=js"

import "./Availability.vue?vue&type=style&index=0&id=85277990&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src214510003/src/oldmillvillagerentals/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85277990"]])

export default __exports__